import type { UpgradePlanName } from '@workspace/global-utils';

export const OFFER_COUNTDOWN_TICK_MS = 1000;
export const OFFER_POSITION_STORAGE_KEY = 'exclusive-offer-position';

export const PLAN_RANK: Record<UpgradePlanName, number> = {
  Starter: 1,
  Professional: 2,
  Business: 3,
};

// Whole amounts drop the cents ("$25"), anything else keeps two places ("$12.50").
export function formatPlanPrice(amount: number, currency = 'USD'): string {
  const fractionDigits = Number.isInteger(amount) ? 0 : 2;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function getCurrencySymbol(currency: string): string {
  return (
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? currency
  );
}
